import angular from 'angular';

class AppSvc {
    /* @ngInject */
    constructor($http, CONF) {
        this.$http = $http;
        this.CONF = CONF;

        this.VERSION_URL = '/misc/version.json';
        this.VERSION_BUSINESS_CONTROL = '/v1/businesscontrol/version';
        this.VERSION_GED = '/v1/ged/version';
        this.SY_COMPONENTS_URLS = '/v1/environment/sy-components-urls';
        this.VERSION_GIS = '/v1/gis/version';
        this.VERSION_EINVOICING = '/v1/einvoicing/version';
        this.VERSION_LIFECYCLE = '/v1/lifecycle/version';
    }

    getKissFOVersion() {
        return this.$http.get(this.CONF.apiContext + this.VERSION_URL);
    }

    getKissBOVersion() {
        return this.$http.get(this.CONF.appContext + this.VERSION_URL);
    }

    getEpdfVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.proxyEpdf + this.VERSION_URL);
    }

    getZedocVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.proxyZeDoc + this.VERSION_URL);
    }

    getPrePasrelVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.proxyPrePasrel + this.VERSION_URL);
    }

    getPasrelEmreVersion() {
        return this.$http.get(this.CONF.pslEmreContext + this.VERSION_URL);
    }

    getPasrelMetiersVersion() {
        return this.$http.get(this.CONF.pslMetiersContext + this.VERSION_URL);
    }

    getBusinessControlVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.VERSION_BUSINESS_CONTROL);
    }

    getGedVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.VERSION_GED);
    }

    getDocRepoVersion() {
        return this.$http.get(this.CONF.proxyDocRepo + this.VERSION_URL);
    }

    getSyComponentsUrls() {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.SY_COMPONENTS_URLS);
    }

    getGisVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.VERSION_GIS);
    }

    getEInvoicingVersion() {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.VERSION_EINVOICING);
    }

    getLifeCycleVersion(lifecycleStatus) {
        return this.$http.get(this.CONF.apiContext + this.CONF.apiBaseUrl + this.VERSION_LIFECYCLE + '?lifeCycleVersionType=' + lifecycleStatus);
    }
}

angular.module('app.core').service('AppSvc', AppSvc);
